import { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

import experienceHero from "../../../assets/dambulla.jpg";

import dambulla1 from "../../../assets/dambulla.jpg";
import dambulla2 from "../../../assets/Religious.jpg";
import dambulla3 from "../../../assets/Sri Lanka Highlights Tour.jpg";

function Dambulla() {

    const [activeImage, setActiveImage] = useState(dambulla1);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${experienceHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Dambulla
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        The Cultural Heart of Sri Lanka’s Central Plains
                    </p>
                </div>
            </section>

            {/* ================= DAMBULLA DESTINATION ================= */}
            <section className="bg-white py-16 px-4 sm:px-8 lg:px-20">
                <div className="max-w-7xl mx-auto">

                    {/* Title */}
                    <h2
                        data-aos="fade-up"
                        className="text-center text-2xl sm:text-3xl md:text-4xl font-semibold text-blue-900 tracking-wide"
                    >
                        Discover Dambulla
                    </h2>

                    {/* Content */}
                    <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                        {/* Text Content */}
                        <div data-aos="fade-right" className="space-y-5 text-gray-700 text-sm sm:text-base leading-relaxed">

                            <p>
                                Dambulla is one of Sri Lanka’s most important cultural and commercial towns, located at the
                                crossroads of the country’s Cultural Triangle. It is best known for its ancient cave
                                temples, but the town also serves as a gateway to many of Sri Lanka’s most famous
                                historical and natural attractions.
                            </p>

                            <p>
                                The Dambulla Cave Temple complex, a UNESCO World Heritage Site, remains the town’s spiritual
                                heart. Its beautifully painted caves and Buddha statues reflect more than two thousand
                                years of Buddhist heritage.
                            </p>

                            <p>
                                Beyond the temples, Dambulla is home to Sri Lanka’s largest wholesale fruit and vegetable
                                market, supplying produce to the entire island. The surrounding countryside is filled
                                with farmlands, lakes, and forest reserves, offering a glimpse into rural Sri Lankan life.
                            </p>

                            <p>
                                Dambulla is also a perfect base for exploring nearby attractions such as Sigiriya Rock,
                                Pidurangala, Minneriya National Park, and Polonnaruwa — making it an ideal hub for
                                travelers seeking culture, wildlife, and scenic landscapes in one destination.
                            </p>

                        </div>

                        {/* Image Section */}
                        <div data-aos="fade-left" className="relative">

                            {/* Main Image */}
                            <img
                                src={activeImage}
                                alt="Dambulla"
                                className="rounded-lg shadow-xl w-full h-[350px] object-cover transition duration-300"
                            />

                            {/* Thumbnail Strip */}
                            <div className="flex gap-3 mt-4 justify-center">

                                {[dambulla1, dambulla2, dambulla3].map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        onClick={() => setActiveImage(img)}
                                        className={`w-20 h-14 object-cover rounded-md shadow cursor-pointer transition
                                        ${activeImage === img
                                                ? "ring-2 ring-blue-600 scale-105"
                                                : "opacity-70 hover:opacity-100"
                                            }`}
                                        alt="thumbnail"
                                    />
                                ))}

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94743412910"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default Dambulla;
